/**
 * Nomes de classe do Brain original (`brainClassNames.js` e
 * `brainSubClassNames.js`), sem as entradas de IDE, planos e créditos. O CSS em
 * `estilo/` é o do original; estes nomes são o contrato entre ele e o JSX.
 */

export const b = {
    root: 'brain-shell brain-shell__root',
    rootEmbedded: 'brain-shell brain-shell__root brain-shell__root--embedded',
    sidebar: 'brain-shell__sidebar',
    sidebarCollapsed: 'brain-shell__sidebar--collapsed',
    sidebarHeader: 'brain-shell__sidebar-header',
    sidebarBrandLogo: 'brain-shell__sidebar-brand-logo',
    sidebarBrandRow: 'brain-shell__sidebar-brand-row',
    sidebarCollapseBtn: 'brain-shell__sidebar-collapse-btn',
    sidebarMenu: 'brain-shell__sidebar-menu',
    sidebarMenuItem: 'brain-shell__sidebar-menu-item',
    sidebarMenuItemActive: 'brain-shell__sidebar-menu-item--active',
    sidebarMenuItemLabel: 'brain-shell__sidebar-menu-item-label',
    sidebarSectionLabel: 'brain-shell__sidebar-section-label',
    sidebarRecentSection: 'brain-shell__sidebar-recent-section',
    sidebarRecentList: 'brain-shell__sidebar-recent-list',
    sidebarEmpty: 'brain-shell__sidebar-empty',
    conversationRecentRow: 'brain-shell__conversation-recent-row',
    conversationRecentItemActive: 'brain-shell__conversation-recent-row--active',
    conversationRecentTitle: 'brain-shell__conversation-recent-title',
    conversationRecentActions: 'brain-shell__conversation-recent-actions',
    conversationRecentActionBtn: 'brain-shell__conversation-recent-action-btn',
    conversationRecentEditInput: 'brain-shell__conversation-recent-edit-input',
    mainContent: 'brain-shell__main-content',
    mainContentConversation: 'brain-shell__main-content--conversation',
    mainContentChat: 'brain-shell__main-content--chat',
    mainContentVoice: 'brain-shell__main-content--voice',
    brandGradient: 'brain-shell__brand-gradient',
    welcomeContainer: 'brain-shell__welcome-container',
    greetingTitle: 'brain-shell__greeting-title',
    welcomeComposerBlock: 'brain-shell__welcome-composer-block',
    inputContainer: 'brain-shell__input-container',
    composerShell: 'brain-shell__composer-shell',
    inputBox: 'brain-shell__input-box',
    textArea: 'brain-shell__text-area',
    inputFooter: 'brain-shell__input-footer',
    inputFooterLeft: 'brain-shell__input-footer-left',
    inputFooterRight: 'brain-shell__input-footer-right',
    modelSelectorWrap: 'brain-shell__model-selector-wrap',
    modelSelector: 'brain-shell__model-selector',
    modelSelectorOpen: 'brain-shell__model-selector--open',
    iconBtn: 'brain-shell__icon-btn',
    iconBtnRecording: 'brain-shell__icon-btn brain-shell__icon-btn--recording',
    sendBtn: 'brain-shell__send-btn',
    toolChip: 'brain-shell__tool-chip',
    voiceRecordingBar: 'brain-shell__voice-recording-bar',
    voiceRecordingDot: 'brain-shell__voice-recording-dot',
    voiceIconBtn: 'brain-shell__voice-icon-btn',
    voiceIconBtnSave: 'brain-shell__voice-icon-btn brain-shell__voice-icon-btn--save',
    voiceIconBtnCancel: 'brain-shell__voice-icon-btn brain-shell__voice-icon-btn--cancel',
    quickActionsGrid: 'brain-shell__quick-actions-grid',
    quickActionCard: 'brain-shell__quick-action-card',
    quickActionIcon: 'brain-shell__quick-action-icon',
    quickActionTitle: 'brain-shell__quick-action-title',
    chatContainer: 'brain-shell__chat-container',
    chatHeader: 'brain-shell__chat-header',
    chatHeaderBrand: 'brain-shell__chat-header-brand',
    chatHeaderRight: 'brain-shell__chat-header-right',
    chatHeaderTools: 'brain-shell__chat-header-tools',
    chatHeaderActionsPlain: 'brain-shell__chat-header-actions-plain',
    helpBtnPlain: 'brain-shell__help-btn-plain',
    modelBadge: 'brain-shell__model-badge',
    chatHeaderTitle: 'brain-shell__chat-header-title',
    messagesArea: 'brain-shell__messages-area',
    messageRow: 'brain-shell__message-row',
    messageRowUser: 'brain-shell__message-row brain-shell__message-row--user',
    messageRowUserInner: 'brain-shell__message-row-user-inner',
    messageUserHeader: 'brain-shell__message-user-header',
    messageUserActions: 'brain-shell__message-user-actions',
    messageActionBtn: 'brain-shell__message-action-btn',
    messageRowAssistant: 'brain-shell__message-row brain-shell__message-row--assistant',
    messageLabelUser: 'brain-shell__message-label brain-shell__message-label--user',
    messageLabelAssistant: 'brain-shell__message-label brain-shell__message-label--assistant',
    messageContentUser: 'brain-shell__message-content brain-shell__message-content--user',
    messageContentAssistant: 'brain-shell__message-content brain-shell__message-content--assistant',
    toolBadge: 'brain-shell__tool-badge',
    typingIndicator: 'brain-shell__typing-indicator',
    workingBar: 'brain-shell__working-bar',
    bottomInput: 'brain-shell__bottom-input',
    bottomInputMenuOpen: 'brain-shell__bottom-input--menu-open',
    modelPickerDropdown: 'brain-shell__model-picker-dropdown',
    modelPickerSection: 'brain-shell__model-picker-section',
    modelPickerProviderRow: 'brain-shell__model-picker-provider-row',
    modelPickerProviderLabel: 'brain-shell__model-picker-provider-label',
    modelPickerItem: 'brain-shell__model-picker-item',
    modelPickerItemActive: 'brain-shell__model-picker-item--active',
    modelPickerItemBody: 'brain-shell__model-picker-item-body',
    modelPickerItemName: 'brain-shell__model-picker-item-name',
    modelPickerItemDesc: 'brain-shell__model-picker-item-desc',
    modelPickerDivider: 'brain-shell__model-picker-divider',
    modelMenuItem: 'brain-shell__model-menu-item',
    fileModal: 'brain-shell__file-sheet',
    fileModalHeader: 'brain-shell__file-modal-header',
    fileModalTitle: 'brain-shell__file-modal-title',
    fileModalContent: 'brain-shell__file-modal-content',
    fileModalPre: 'brain-shell__file-modal-pre',
    fileModalTable: 'brain-shell__file-modal-table',
    downloadBtn: 'brain-shell__download-btn',
    fileModalFooter: 'brain-shell__file-modal-footer',
    attachLibraryBtn: 'brain-shell__attach-library-btn',
    attachLibraryBadge: 'brain-shell__attach-library-badge',
    libraryModal: 'brain-shell__library-sheet',
    libraryItem: 'brain-shell__library-item',
    libraryItemIcon: 'brain-shell__library-item-icon',
    libraryItemInfo: 'brain-shell__library-item-info',
    libraryItemTitle: 'brain-shell__library-item-title',
    libraryItemMeta: 'brain-shell__library-item-meta',
    libraryEmpty: 'brain-shell__library-empty',
    librarySection: 'brain-shell__library-section',
    voiceModeBtn: 'brain-shell__voice-mode-btn',
    voiceModeBtnActive: 'brain-shell__voice-mode-btn brain-shell__voice-mode-btn--active',
    iconBtnPlain: 'brain-shell__icon-btn-plain',
    loadingCenter: 'brain-shell__loading-center',
} as const;

export const s = {
    root: 'brain-sub__root',
    inner: 'brain-sub__inner',
    innerWide: 'brain-sub__inner brain-sub__inner--wide',
    header: 'brain-sub__header',
    headerRow: 'brain-sub__header-row',
    title: 'brain-sub__title',
    lead: 'brain-sub__lead',
    actions: 'brain-sub__actions',
    btnGhost: 'brain-sub__btn brain-sub__btn--ghost',
    btnPrimary: 'brain-sub__btn brain-sub__btn--primary',
    btnDark: 'brain-sub__btn brain-sub__btn--dark',
    searchWrap: 'brain-sub__search-wrap',
    searchIcon: 'brain-sub__search-icon',
    searchInput: 'brain-sub__search-input',
    clearBtn: 'brain-sub__clear-btn',
    list: 'brain-sub__list',
    row: 'brain-sub__row',
    rowActive: 'brain-sub__row--active',
    rowTitle: 'brain-sub__row-title',
    rowDate: 'brain-sub__row-date',
    empty: 'brain-sub__empty',
    loading: 'brain-sub__loading',
    grid: 'brain-sub__grid',
    grid2: 'brain-sub__grid brain-sub__grid--2',
    card: 'brain-sub__card',
    cardActive: 'brain-sub__card--active',
    cardTop: 'brain-sub__card-top',
    cardBrand: 'brain-sub__card-brand',
    cardIcon: 'brain-sub__card-icon',
    cardTitle: 'brain-sub__card-title',
    cardDesc: 'brain-sub__card-desc',
    cardMeta: 'brain-sub__card-meta',
    section: 'brain-sub__section',
    sectionTitle: 'brain-sub__section-title',
    optionGrid: 'brain-sub__option-grid',
    optionCard: 'brain-sub__option-card',
    optionCardActive: 'brain-sub__option-card--active',
    optionLabel: 'brain-sub__option-label',
    optionHint: 'brain-sub__option-hint',
    field: 'brain-sub__field',
    fieldLabel: 'brain-sub__field-label',
    textarea: 'brain-sub__textarea',
    input: 'brain-sub__input',
    switchRow: 'brain-sub__switch-row',
    preview: 'brain-sub__preview',
    menuOverlay: 'brain-menu__overlay',
    menuPanel: 'brain-menu__panel',
    menuRow: 'brain-menu__row',
    menuRowIcon: 'brain-menu__row-icon',
    menuRowRight: 'brain-menu__row-right',
    menuDivider: 'brain-menu__divider',
    dialogTitle: 'brain-sub__dialog-title',
    dialogLead: 'brain-sub__dialog-lead',
} as const;
